import { render, staticRenderFns } from "./Shipments.vue?vue&type=template&id=ed916d90&scoped=true"
import script from "./Shipments.vue?vue&type=script&lang=js"
export * from "./Shipments.vue?vue&type=script&lang=js"
import style0 from "./Shipments.vue?vue&type=style&index=0&id=ed916d90&prod&scoped=true&lang=css"
import style1 from "./Shipments.vue?vue&type=style&index=1&id=ed916d90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed916d90",
  null
  
)

export default component.exports